import { dispatcher, IEvent, ingenuity } from "@quest/base-core";
import {
  FreeGameReelPanelControllerBehavior,
  SlotEventConstantsBehavior,
} from "@quest/murka-games-behavior-panther/dist";
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SlotEventConstants } from "@quest/slot-core";

export class FreeGameReelPanelControllerGame extends FreeGameReelPanelControllerBehavior {
  private cascadeOnReelsCounter: number = 0;

  /**
   * subscribe all events
   */
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.FG_CASCADE_SPIN_COMPLETE, this.onFgCascadeSpinComplete, this);
    dispatcher.on(eventDispatchers.UDPATE_NEW_FG_REELSET, this.updateReelsets, this);
  }

  /**
   * unsubscribe all events
   */
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.FG_CASCADE_SPIN_COMPLETE, this.onFgCascadeSpinComplete, this);
    dispatcher.off(eventDispatchers.UDPATE_NEW_FG_REELSET, this.updateReelsets, this);
  }
  /**
   * This method is use to update reelsets
   */
  private updateReelsets() {
    this.reelView.getModel().setReelsets([(ingenuity.parserModel as GameParserModel).getFreeSpinReel()]);
  }

  /**
   * This method is use to show win after cascading is completed
   */
  private onFgCascadeSpinComplete(): void {
    this.cascadeOnReelsCounter += 1;
    if (this.cascadeOnReelsCounter === (ingenuity.parserModel as GameParserModel).getCurrentCascadingReelNumber()) {
      this.cascadeOnReelsCounter = 0;
      const currenCascadeCount: number = (ingenuity.parserModel as GameParserModel).getCascadingCount();
      (ingenuity.parserModel as GameParserModel).setCascadingCount(currenCascadeCount - 1);
      if ((ingenuity.parserModel as GameParserModel).getCascadeWin()) {
        dispatcher.fireEvent(eventDispatchers.RESET_CASCADE_COUNTER);
        dispatcher.fireEvent(eventDispatchers.CHECK_AND_SHOW_NEXT_CASCADE_PRESENTATION);

      } else {
        dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOTAL_WIN_MSG);
        dispatcher.fireEvent(eventDispatchers.CHECK_AND_SHOW_NEXT_CASCADE_PRESENTATION);
      }
    }
  }

  // Overrided to destroy the current cascde spine data on nextspin
  protected onSpinReel(evt: IEvent): void {
    super.onSpinReel(evt);
    dispatcher.fireEvent(eventDispatchers.RESET_PROGRESS_BAR_IN_FREEGAME);
    dispatcher.fireEvent(eventDispatchers.FG_BURST_SYMBOLS_DESTROY);
  }
  /**
   * overrided to remove check for win after reel  stop flow and add CHECK_AND_SHOW_NEXT_CASCADE_PRESENTATION
   */
  protected onSpinComplete(evt: any): void {
    this.reelView.setStopNow(false);
    this.reelView.getModel().quickSpin = false;
    dispatcher.fireEvent(eventDispatchers.CHECK_AND_SHOW_NEXT_CASCADE_PRESENTATION);
    dispatcher.off(SlotEventConstants.FG_SHOW_ANTICIPATION, this.showAnticipation);
    dispatcher.fireEvent(SlotEventConstantsBehavior.SET_IS_REEL_SPINNING, false);
    if ((ingenuity.parserModel as GameParserModel).getIsFreeSpintriggered() || (ingenuity.parserModel as GameParserModel).getIsFreeSpinRetriggered()) {
      dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
    }
    dispatcher.fireEvent(SlotEventConstants.FG_SHOW_SPIN_BTN_HIDE_STOP_BTN);
    

  }
}
